const DB_NAME = "tarka-hr-offline-scanner";
const STORE_NAME = "offline-scanner-events";

const openDb = () => new Promise((resolve, reject) => {
  const request = window.indexedDB.open(DB_NAME, 1);
  request.onupgradeneeded = () => {
    const db = request.result;
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME, { keyPath: "id" });
    }
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

const encode = (value) => new TextEncoder().encode(value);
const decode = (value) => new TextDecoder().decode(value);

const bytesToBase64 = (bytes) => window.btoa(String.fromCharCode(...new Uint8Array(bytes)));
const base64ToBytes = (value) => Uint8Array.from(window.atob(value), (char) => char.charCodeAt(0));

const deriveKey = async (scopeKey) => {
  const hash = await window.crypto.subtle.digest("SHA-256", encode(scopeKey));
  return window.crypto.subtle.importKey("raw", hash, "AES-GCM", false, ["encrypt", "decrypt"]);
};

const encryptPayload = async (payload, scopeKey) => {
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const key = await deriveKey(scopeKey);
  const cipherBuffer = await window.crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, encode(JSON.stringify(payload)));
  return { iv: bytesToBase64(iv), cipher: bytesToBase64(cipherBuffer) };
};

const decryptPayload = async (record, scopeKey) => {
  const key = await deriveKey(scopeKey);
  const plainBuffer = await window.crypto.subtle.decrypt({ name: "AES-GCM", iv: base64ToBytes(record.iv) }, key, base64ToBytes(record.cipher));
  return JSON.parse(decode(plainBuffer));
};

const runStore = async (mode, handler) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, mode);
    const store = transaction.objectStore(STORE_NAME);
    const result = handler(store);
    transaction.oncomplete = () => resolve(result);
    transaction.onerror = () => reject(transaction.error);
  });
};

export const getOfflineScannerRecords = async (scopeKey) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, "readonly");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.getAll();
    request.onsuccess = async () => {
      try {
        const items = await Promise.all(request.result.filter((item) => item.scopeKey === scopeKey).map(async (item) => ({ id: item.id, ...(await decryptPayload(item, scopeKey)) })));
        resolve(items.sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1)));
      } catch (error) {
        reject(error);
      }
    };
    request.onerror = () => reject(request.error);
  });
};

export const saveOfflineScannerRecord = async (record, scopeKey) => {
  const encrypted = await encryptPayload(record, scopeKey);
  await runStore("readwrite", (store) => store.put({ id: record.id, scopeKey, ...encrypted }));
  return record;
};

export const deleteOfflineScannerRecord = async (id) => {
  await runStore("readwrite", (store) => store.delete(id));
};

export const replaceOfflineScannerRecord = async (record, scopeKey) => {
  const encrypted = await encryptPayload(record, scopeKey);
  await runStore("readwrite", (store) => store.put({ id: record.id, scopeKey, ...encrypted }));
};